import { t } from "i18next";
import CompanyService from "../services/CompanyService";

class CurrencyUtils {
    static companyService = new CompanyService();
    
    /**
     * Method to format currency
     * @param {number} amount - Amount to be formatted
     * @returns {string} - Formatted currency
     */
    static currency(amount) {
        try {
            // Get the currency code synchronously from localStorage
            const currencyCode = localStorage.getItem('currencyCode') || 'PLN';
            if (amount !== undefined && amount !== null) {
                return amount.toLocaleString('pl-PL', { style: 'currency', currency: currencyCode });
            } else {
                return t('global.empty');
            }
        } catch (ex) {
            console.error('CurrencyUtils error ->', ex);
            return t('global.currency-format-error');
        }
    }

    /**
     * Store the currency code in localStorage
     * @param {string} currency - The currency code to store (e.g., 'USD')
     */
    static setCurrency(currency) {
        localStorage.setItem('currencyCode', currency);
    }

    /**
     * Initialize currency from the API or fallback to default
     * @returns {Promise<void>}
     */
    static async initializeCurrency() {      
        try {
            const fetchedCurrency = await CurrencyUtils.companyService.getCurrency();
            if (fetchedCurrency) {
                CurrencyUtils.setCurrency(fetchedCurrency.value);
            } else {
                CurrencyUtils.setCurrency('PLN');
            }
        } catch (error) {
            console.error('Failed to fetch currency from API:', error);
            CurrencyUtils.setCurrency('PLN'); // Fallback to USD if API fails
        }
        
    }
}

export default CurrencyUtils;